import type { RootState } from '@generalTypes/rootStateTypes';
import { KovResourcePicker } from '@kathondvla/react-shared-components/src/components';
import {
  CurriculumTypeKeys,
  type DropDownOptionsType,
  type EditAsideCurriculumType,
} from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { set } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import { selectCurrentCurriculumType } from './asideCurriculumTypeSelectors';

const AsideCurriculumType: React.FC<{
  config: EditAsideCurriculumType;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();
  const editHref = useEditHref();

  const selectedOption: DropDownOptionsType = useSelector((state: RootState) =>
    selectCurrentCurriculumType(state, config),
  );

  const onChange = (value: DropDownOptionsType) => {
    const okan = value.key === CurriculumTypeKeys.OKAN;
    const foundational = value.key === CurriculumTypeKeys.FOUNDATIONAL;

    const payload = {};
    set(payload, 'foundational', foundational);
    set(payload, 'okan', okan);

    dispatch(patchNodeAction(getResourceKey(editHref), payload));
  };

  return (
    <div style={{ maxWidth: '400px' }}>
      <label className="control-label">{config.label}</label>

      <KovResourcePicker
        value={selectedOption}
        localData={config.options}
        disabled={readonly}
        clearable={false}
        onChange={onChange}
        menuPlacement="bottom"
        disableSearch={true}
        optionValue={(o: DropDownOptionsType) => o.key}
        optionTemplate={(o: DropDownOptionsType) => o.label}
      />
    </div>
  );
};

export default AsideCurriculumType;

AsideCurriculumType.displayName = 'AsideCurriculumType';

AsideCurriculumType.propTypes = {
  config: any,
  readonly: any,
};
